import React from "react"

interface FooterTableProps {
	content: React.ReactNode
}

const FooterTable: React.FC<FooterTableProps> = ({ content }): JSX.Element => {
	return <div className="container-footer-table">{content}</div>
}

export default FooterTable
